<template>
  <div class="c-price-pkg">
    <div class="c-price-pkg-block">
      <Pricing :pricingList="pkgList" :isLiuziPage="isLiuziPage" />
    </div>
  </div>
</template>

<script>
import { PricePackageList } from '@/common/constants/price';
import Pricing from '@/views/price/src/modules/Pricing.vue';

export default {
  name: 'PricePackages',
  props: {
    pkg: Object,
    isLiuziPage: Boolean,
  },
  components: {
    Pricing,
  },
  data() {
    return {
      pkgList: PricePackageList,
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.c-price-pkg {
  @media screen and (max-width: $width-m) {
    display: flex;
    overflow-x: auto;
    white-space: nowrap;
  }
  &-block {
    max-width: 1200px;
    margin: 0 auto;
  }
}
</style>
